import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Calendar, Clock, ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import { IMAGES, ARTICLES } from "@/data/site";

export default function Blog() {
  return (
    <div data-testid="page-blog">
      <PageHero
        crumb="Artikel"
        eyebrow="Articles & Insights"
        title="Solar energy insights for your business decisions"
        desc="Guides, regulations, and financial analysis on solar PV in Indonesia, curated by our expert team."
        image={IMAGES.farmRows}
      />

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {ARTICLES.map((a, i) => (
            <motion.article
              key={a.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="group flex flex-col overflow-hidden rounded-2xl bg-white shadow-sm aje-card-hover"
            >
              <Link
                to={`/artikel/${a.id}`}
                data-testid={`blog-card-${a.id}`}
                className="flex h-full flex-col"
              >
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={IMAGES[a.img]}
                    alt={a.title}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <span className="absolute top-3 left-3 rounded-full bg-blue-900 px-3 py-1 text-xs font-semibold text-white">
                    {a.category}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <div className="flex items-center gap-4 text-xs text-slate-400">
                    <span className="inline-flex items-center gap-1">
                      <Calendar className="h-3.5 w-3.5" /> {a.date}
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <Clock className="h-3.5 w-3.5" /> {a.read}
                    </span>
                  </div>
                  <h3 className="mt-3 font-display text-lg font-bold leading-snug text-slate-900 transition-colors group-hover:text-blue-900">
                    {a.title}
                  </h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600">
                    {a.excerpt}
                  </p>
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      </section>
    </div>
  );
}
